import { combineReducers } from "redux";
import basicRequest from "../../../core/redux/reducers/request";
import basicList from "../../../core/redux/reducers/list";

const list = basicList("INVOICE_LIST");
const show = basicRequest("INVOICE_SHOW");
const uncompensatedJobs = basicList("INVOICE_UNCOMPENSATED_JOBS");

const clientPurchaseOrder = basicRequest("INVOICE_CLIENT_PURCHASE_ORDER");
const clientPurchaseOrderShow = basicRequest("INVOICE_CLIENT_PURCHASE_ORDER_SHOW");
const clientAssignJob = basicList("INVOICE_CLIENT_ASSIGN_JOB");

export default combineReducers({
    list,
    show,
    uncompensatedJobs,
    clientPurchaseOrder,
    clientPurchaseOrderShow,
    clientAssignJob,
});
